import { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router'

export const PasswordResetRedirect = () => {
  const navigate = useNavigate()
  const { token, token_type } = useParams()

  useEffect(() => {
    if (!token || !token_type) {
      return navigate('/forgot-password')
    }

    navigate(`/reset-password?token=${token}&token_type=${token_type}`)
  }, [])

  return <div />
}

export default PasswordResetRedirect
